export const locale = {
  lang: 'tr',
  data: {
    'CIERRE': {
      'LABEL1': 'Genel katılım durumu',
      'LABEL2': 'Anketiniz',
      'LABEL3': 'Anket Tamamlandı',
      'LABEL4': 'Sonuç görmek',
      'LABEL5': 'Hatırlatıcılar gönderiliyor',
      'LABEL6': 'Bugün zaten bir e-posta gönderdiniz',
      'LABEL7': 'Yalnızca açılış gününüzden sonra hatırlatıcı gönderebilirsiniz',
      'LABEL8': 'Bir dakika bekle......',
      'LABEL9': 'Kalan günler',
      'BTN_CIERRE': 'Şimdi sonlandır',
      'ALERT':{
        'MESSAGE': 'Beklenen anketi kapatmak için onaylıyor musunuz?',
        'BTN_CONFIRM': 'Evet',
        'BTN_CANCEL': 'Hayır',
        'OK':'tamam',
      },
      'ALERT_RE':{
        'MESSAGE': '¿Hatırlatıcıları göndermek istediğinizden emin misiniz?',
        'BTN_CONFIRM': 'Evet',
        'BTN_CANCEL': 'Hayır',
        'OK':'tamam',
      },
      'LINK': 'Katılım durumu takibi için aşağıdaki linki kullanabilirsiniz',
      'LINKENCUESTA': 'Anketin mevcut ilerlemesini görüntülemek için bağlantı oluşturur:',
      'ACTIONS':{
        'TITULO': 'Sonlandırma',
        'TITULO_ACTUALIZADO': 'Hatırlatmalar',
        'TITULO_ACCESS': 'Ankete erişim',
        'WANNADO': 'Anketinizi sonlandırmak istiyor musunuz?',
        'TITULO_VIRSMS': 'Sanal SMS portalı',
          'TITULO_MYCODE': 'GetMyCode.culturalgo.com portalı',
          'TITULO_BTNMYCODE': 'GetMyCode portalına gidin',
      },
      'COMPLETO':{
        'TAG': 'Anket başarıyla tamamlandı',
        'CARDTIT': 'Sonuç sorgusu',
        'LINK': 'Ankette elde edilen sonuçları görmek için bir sonraki bağlantıya gidin'
      },
      'PULSE':{
        /// Survey advancement
        'LABELPRO':'Anket ilerlemesi',
        'LINKEN': 'Anket bağlantısı',
        'LINKRES': 'Bağlantı sonucu',
        'ENCUESTANOENVIADA': 'Henüz Nabız Kontrolü anketi yayınlanmadı',
      },
      'CIERRE':{
        'BCONTEOS':'Sayım portalı',
        'BACCESO':'Erişim anahtarı oluştur',
        'LINKPORTAL': 'Erişim bağlantısını sayma portalına kopyala',
        'COPYLINK':'Panonuza kopyalandı',
        'REMANDER':'Hatırlatmalar',
        'REMANDERC2':'Anketi bitirmeyen kişilere hatırlatma',
        'REMANDER1':'Henüz anketinize girmemiş kişilere hatırlatmalar',
        'REMANDER2':'Başlayan ve hala bitirmeyen kişilere hatırlatmalar',
        'REMANDER_TURQUIA':'Tüm katılımcılara hatırlatma gönder',
        'GETURLSURV_1': 'Anket erişim sağlayıcısı bağlantısı oluşturun',
        'GETURLSURV_2': 'Anket erişim sağlayıcısı için bağlantı oluşturuldu, artık aynı düğmeye tıklayarak kopyalayabilirsiniz',
        'GETURLSURV_3': 'Anket erişim sağlayıcı bağlantısını kopyalayın',
        'ASIGUSERDEMO':'Bir şifre atamak',
      },
      'MOD_TEX_SEND_RECO':'E-mail göndermek...',
    },
  }
};
